






































































































































































































import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
import {
  UnitsApi,
  UnitFacility,
  Document,
  DocumentRequest,
  FilesApi,
  PresignedurlApi,
} from '@compassdigital/foodworks.ts.sdk';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import AppModule from '@/store/modules/app';
import Dropzone from '@/components/Form/FileUploadForm/Dropzone/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import UnitsUtil from '@/util/UnitUtil';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import UserModule from '@/store/modules/user';
import ToastModule from '@/store/modules/toast';
import moment from 'moment';
import Axios from 'axios';

@Component({
  components: {
    VueTimepicker,
    Textfield,
    PrimaryButton,
    TextButton,
    Dropzone,
  },
})
export default class FacilityEdit extends Vue {
  @PropSync('facilityInfo', {}) FacilityInformation!: any;

  @PropSync('facilityModal', {}) facilityModalInfo!: any;

  @PropSync('docImagesSyn', {}) docImages!: any;

  @Prop() error!: boolean;

  @Prop() saving!: boolean;

  public docObj: Document[] = [];

  public loading: boolean = false;

  public docCacheFiles: [] = [];

  public mounted() {
    if (this.docImages) {
      this.docObj = this.docImages;
    }
  }

  public onCancel() {
    this.$emit('cancelFacilityPage');
  }

  public onSaveDetails() {
    this.$emit('onSave', this.FacilityInformation);
  }

  public onPopupDialog() {
    this.facilityModalInfo.dialogSync = true;
  }

  public get getNumericPrepCount() {
    const numbers = /^[0-9]+$/;
    if (this.FacilityInformation.avgPrepCount.match(numbers)) {
      this.facilityModalInfo.numericError = false;
      return false;
    }
    this.facilityModalInfo.numericError = true;
    return true;
  }

  public get getFormatArrivalTime() {
    const reg = /((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))/;
    if (this.FacilityInformation.arrivalTime.match(reg)) {
      this.facilityModalInfo.timeError = false;
    } else {
      this.facilityModalInfo.timeError = true;
      return true;
    }
    return false;
  }

  public get getFormatReportingTime() {
    const reg = /((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))/;
    if (this.FacilityInformation.reportingTime.match(reg)) {
      this.facilityModalInfo.timeError = false;
    } else {
      this.facilityModalInfo.timeError = true;
      return true;
    }
    return false;
  }

  public get getFormatServiceTime() {
    const reg = /((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))/;
    if (this.FacilityInformation.serviceTime.to.match(reg)) {
      this.facilityModalInfo.timeError = false;
    } else {
      this.facilityModalInfo.timeError = true;
      return true;
    }
    return false;
  }

  public get validateTime() {
    const regExp = /(\d{1,2}):(\d{1,2}) ?([AaPp][Mm])/;
    if (this.FacilityInformation.serviceTime.to.match(regExp)) {
      const startTime = moment(this.FacilityInformation.serviceTime.from, 'hh:mm A');
      const endTime = moment(this.FacilityInformation.serviceTime.to, 'hh:mm A');
      const isBetween = startTime.isAfter(endTime);
      if (!isBetween) {
        this.facilityModalInfo.timeError = false;
      } else {
        this.facilityModalInfo.timeError = true;
        return true;
      }
    } else {
      this.facilityModalInfo.timeError = true;
      return true;
    }
    return false;
  }

  public async onDone(documents: any) {
    const totalFiles = [...documents, ...this.docObj];
    const presignedApi = new PresignedurlApi(AppModule.apiConfig);
    const api = new FilesApi(AppModule.apiConfig);
    if (totalFiles.length <= 15) {
      const imageDoc = !documents
        || documents.map(async (doc: any) => {
          try {
            const response = await presignedApi.presignedUrl(doc.name, doc.type);
            const { data: { preSignedUrl, getUrl } } = response as any;
            const url = preSignedUrl;
            await Axios.put(url, doc.file);
            const documentData: DocumentRequest = {
              documentName: doc.name,
              documentType: doc.type,
              url: getUrl,
            };
            const fileResponse = await api.postFile(documentData);
            const { data } = fileResponse;
            if (data) {
              return data;
            }
          } catch (err) {
            const { error } = err.response.data;
            ToastModule.setToast({
              message: error.message,
              timeout: 5000,
            });
          }
          return '';
        });
      this.loading = true;
      Promise.all(imageDoc).then((images) => {
        this.loading = false;
        this.docObj = [...this.docObj, ...images] as Array<Document>;
        const pictures: any = [];
        const document = !this.docObj
          || this.docObj.map((docFile: Document) => {
            const { id } = docFile;
            if (id) {
              pictures.push(id);
            }
            return null;
          });
        this.FacilityInformation.unitPictures = pictures;
      });
    } else {
      const error = 'User can not upload more than 15 files';
      ToastModule.setToast({
        message: error,
        timeout: 5000,
      });
    }
  }

  public async deleteDoc(doc: Document) {
    const { unitPictures } = this.FacilityInformation;
    const { id } = doc;
    const objDoc = !this.docObj
      || this.docObj.filter((imageDoc: Document) => imageDoc.id !== id);
    this.docObj = objDoc;

    let picInfo: DocumentRequest[] = [];
    picInfo = !unitPictures || unitPictures.filter((picID: string) => picID !== id);
    this.FacilityInformation.unitPictures = picInfo;
  }

  public get serviceTimerError() {
    if (this.FacilityInformation.serviceTime.to === '' && this.error === true) {
      return true;
    }
    if (
      this.FacilityInformation.serviceTime.from === ''
      && this.error === true
    ) {
      return true;
    }
    return false;
  }

  get adminUser() {
    if (
      UserModule.currentRole === 'fw_admin'
      || UserModule.currentRole === 'fw_manager'
      || UserModule.currentRole === 'unit_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }
}
